







































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import LayerLegendImage from '@/components/plugins/legend/LayerLegendImage.vue';
import VectorLegend from '@/components/plugins/legend/VectorLegend.vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import StyleRule from '@/models/map-context/style/StyleRule';
import Plugin from '@/models/plugin/Plugin';
import { EVENTS } from '@/services/EventBus';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

interface LegendSeries {
  title: string;
  rules: StyleRule[];
}

@Component({
  props: {
    plugin: {},
  },
  components: {
    LayerLegendImage,
    VectorLegend,
  },
})
export default class MapLegendCard extends BaseComponent {
  plugin!: Plugin;

  collapsed = false;

  legendRefreshToken = 0;

  mounted() {
    this.getEventBus().$on(EVENTS.LAYER_UPDATED, this.onLayerUpdated);
  }

  beforeDestroy() {
    this.getEventBus().$off(EVENTS.LAYER_UPDATED, this.onLayerUpdated);
  }

  onLayerUpdated = () => {
    this.legendRefreshToken += 1;
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  get visibleLayers(): LayerConfig[] {
    // Force recompute when a layer style is applied (WMS SLD, etc.)
    void this.legendRefreshToken;
    return this.getMapService().getOrderedLayerList().filter(
      (layer: LayerConfig) => layer.isLegendDisplayed
        && layer.isLayerVisible()
        && !layer.baseLayer
        && (this.isVectorLayer(layer) || this.hasLegendImage(layer)),
    );
  }

  isVectorLayer(layer: LayerConfig): boolean {
    return layer.isVectorRenderLayer() || !!(layer.isWMS() && layer.useSldBody);
  }

  hasLegendImage(layer: LayerConfig): boolean {
    return layer.isWMS()
      || !!(layer.legendImageUrl && String(layer.legendImageUrl).trim());
  }

  getSeries(layer: LayerConfig): LegendSeries[] {
    if (layer.complexStyle && typeof layer.complexStyle.isBivariate === 'function'
      && layer.complexStyle.isBivariate()) {
      return [
        { title: this.getSeriesTitle(layer, this.getColorRules(layer)), rules: this.getColorRules(layer) },
        { title: this.getSeriesTitle(layer, this.getSizeRules(layer), 'Taille'), rules: this.getSizeRules(layer) },
      ];
    }
    return [{ title: layer.title, rules: this.getVisibleRules(layer) }];
  }

  getColorRules(layer: LayerConfig): StyleRule[] {
    if (!layer.complexStyle || typeof layer.complexStyle.getColorRules !== 'function') {
      return [];
    }
    return layer.complexStyle.getColorRules().filter(
      (rule: StyleRule) => rule.active && this.inRange(rule),
    );
  }

  getSizeRules(layer: LayerConfig): StyleRule[] {
    if (!layer.complexStyle || typeof layer.complexStyle.getSizeRules !== 'function') {
      return [];
    }
    return layer.complexStyle.getSizeRules().filter(
      (rule: StyleRule) => rule.active && this.inRange(rule),
    );
  }

  getVisibleRules(layer: LayerConfig): StyleRule[] {
    if (!layer.hasRules()) {
      return [];
    }
    return layer.complexStyle.styleRules.filter(
      (rule: StyleRule) => rule.active && this.inRange(rule),
    );
  }

  inRange(item: StyleRule): boolean {
    return item.inRange(this.getMapService().currentScale);
  }

  getLabel(rule: StyleRule): string {
    return rule.label || rule.value;
  }

  getRefreshToken(layer: LayerConfig, rule?: StyleRule): number {
    const layerToken = layer && layer.styleRefreshToken ? layer.styleRefreshToken : 0;
    const ruleToken = rule && rule.refreshToken ? rule.refreshToken : 0;
    return layerToken + ruleToken;
  }

  showSeriesTitle(layer: LayerConfig, series: LegendSeries): boolean {
    const seriesList = this.getSeries(layer);
    return seriesList.length > 1 || series.title !== layer.title;
  }

  getSeriesTitle(
    layer: LayerConfig,
    rules: StyleRule[],
    fallback = '',
  ): string {
    const attr = rules.length > 0 ? this.extractAttributeName(rules[0]) : '';
    return attr || fallback || layer.title;
  }

  extractAttributeName(rule: StyleRule): string {
    if (!rule || !rule.value) {
      return '';
    }
    const match = String(rule.value).match(/^"?([A-Za-z_][A-Za-z0-9_]*)"?\s*(=|>=|<=|<>|<|>|like)/i);
    return match ? match[1] : '';
  }
}
